import {
	dispatchAcknowledgedEvent,
	openResourceSection,
} from '../../core/resourceEvents';
import {
	ROLE_BASED_ACCESS_FILTER_EVENT,
	ROLE_BASED_ACCESS_FOCUS_EVENT,
	ROLE_BASED_ACCESS_SECTION_EVENT,
} from './events';

const SECTIONS = new Set(['profile.role_based_access']);

/**
 * Open the Role-Based Access accordion on the Templates page.
 * @return {Promise<void>} completion acknowledgement
 */
export function openRoleBasedAccessSection() {
	return openResourceSection(
		ROLE_BASED_ACCESS_SECTION_EVENT,
		'profile.role_based_access',
		SECTIONS,
	);
}

/**
 * Filter the Role Profile table to a search term.
 * @param {string} query search text
 * @return {Promise<void>} acknowledgement
 */
export function applyRoleBasedAccessFilter(query) {
	return dispatchAcknowledgedEvent(ROLE_BASED_ACCESS_FILTER_EVENT, {
		query: String(query || '').trim(),
		resource: 'role_based_access',
	});
}

/**
 * Point at one Role Profile's row in the table.
 * @param {string} entityId profile identifier
 * @return {Promise<void>} acknowledgement
 */
export function focusRoleBasedAccess(entityId) {
	if (!entityId) {
		return Promise.reject(new Error('invalid_role_based_access_focus'));
	}
	return dispatchAcknowledgedEvent(ROLE_BASED_ACCESS_FOCUS_EVENT, {
		entityId: String(entityId),
		resource: 'role_based_access',
	});
}
